import { TOGGLE_SETTING, CHANGE_SETTING, PAGE_TITLE, FILE_MANAGER, VERSION, APIBUILDNUMBER, ORI_FILE_MANAGER, PAYMENTPROVIDER, DEFAULT_TAKEPERROW } from '../actions/actions';

const initialSettings = {
    /* Layout fixed. Scroll content only */
    isFixed: true,
    /* Sidebar collapsed */
    isCollapsed: true,
    /* Boxed layout */
    isBoxed: false,
    /* Floating sidebar */
    isFloat: false,
    /* Sidebar show menu on hover only */
    asideHover: false,
    /* Show sidebar scrollbar (dont' hide it) */
    asideScrollbar: false,
    /* Sidebar collapsed with big icons and text */
    isCollapsedText: true,
    /* Toggle for the offsidebar */
    offsidebarOpen: false,
    /* Toggle for the sidebar offcanvas (mobile) */
    asideToggled: false,
    /* Toggle for the sidebar user block */
    showUserBlock: false,
    /* Enables layout horizontal */
    horizontal: false,
    /* Full size layout */
    useFullLayout: false,
    /* Hide footer */
    hiddenFooter: false,
    /* Page Name */
    pageName: "",
    /* file manager url */
    fileManagerUrl: "",
    /* payment provider url */
    paymentProviderUrl: "",
    /* default take per row */
    defaultTakePerRow : ""
};

const settingsReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case TOGGLE_SETTING:
            return {
                ...state,
                [action.name]: !state[action.name]
            }
        case CHANGE_SETTING:
            return {
                ...state,
                [action.name]: action.value
            };
        case PAGE_TITLE:
            return {
                ...state,
                pageName: action.value
            }
        case FILE_MANAGER:
            return {
                ...state,
                fileManagerUrl: action.value
            }
        case ORI_FILE_MANAGER:
            return {
                ...state,
                originalFileManager: action.value
            }
        case VERSION:
            return {
                ...state,
                webVersion: action.value
            }
        case APIBUILDNUMBER:
            return {
                ...state,
                apiBuildNumber: action.value
            }
        case PAYMENTPROVIDER:
            return {
                ...state,
                paymentProviderUrl: action.value
            }
        case DEFAULT_TAKEPERROW : 
            return {
                ...state,
                defaultTakePerRow: action.value
            }
        default:
            return state;
    }
}

export default settingsReducer;